import axios from 'axios'
import useJwt from '../../auth/jwt/useJwt'

const bicloudAxios = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'GET, PUT,POST, DELETE, OPTIONS',
    'X-Frame-Options': 'SAMEORIGIN',
    'X-Content-Type-Options': 'nosniff',
    'X-XSS-Protection': 0,
    'Strict-Transport-Security': 'max-age=31536000',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
    'Content-Type': 'application/json',
  },
})

const jwtConfig = {storageTokenKeyName: 'accessToken', tokenType: 'Bearer'}

// ** Request Interceptor
bicloudAxios.interceptors.request.use(
  (config) => {
    const accessToken = useJwt.getToken()

    if (accessToken) {
      config.headers.Authorization = `${jwtConfig.tokenType} ${JSON.parse(accessToken)}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

// ** Add request/response interceptor
bicloudAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    if (status === 403) {
      return window.location.replace('/cambiar-contraseña')
    } else if (status >= 500 && status <= 599) {
      return window.location.replace('/error-servidor')
    } else if (status === 401) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('userData')
      return window.location.replace('/login')
    } else {
      return Promise.reject({status, data: error.response?.data})
    }
  },
)

export default bicloudAxios
